<div class="detail-container">
  @if (projectPropertyResource.isLoading()) {
    <property-skeleton />
  } @else if (projectPropertyResource.error()) {
    <error-card/>
  } @else {
    @if (projectPropertyResource.value(); as projectProperty) {
      <div class="d-flex gap-4">
        <div>
          <section-header>{{ projectProperty.name() }}</section-header>
          <div class="d-flex flex-wrap gap-4">
              <document-card [style.view-transition-name]="'card-image'" class="document-card">
                @if (projectProperty.hasImageError()) {
                  <span class="text-center" card-content>{{ projectProperty.name() }}</span>
                } @else {
                  <img card-content class="h-100" (error)="projectProperty.handleImageError()" [src]="projectProperty.thumbnailUrl()" alt="image" />
                }
                
                <span card-footer class="font-5">{{projectProperty.name()}}</span>
              </document-card>
            </div>
        </div>
      </div>

      <div class="mt-4">
        <section-header>Project Properties</section-header>

        <div masonry class="masonry-columns">
          @for (category of projectProperty.categories(); track $index) {
            <property-card>
              <div title class="d-flex align-items-center">
                @if(!category.hasImageError) {
                  <img height="50" src="{{category.thumbnailUrl()}}"/>
                }
                <span>{{ category.name() }}</span>
              </div>

              <div content class="d-flex flex-column gap-3 primary-text">
                <property-item-header />

                @for (property of category.properties(); track $index) {
                  <property-item-row [name]="property.name()" [value]="property.values()"></property-item-row>
                }
              </div>
            </property-card>
          } @empty {
            <empty-property-card />
          }
        </div>
      </div>

      <div class="mt-4">
        <carousel [enableHover]="true" [dataSource]="projectProperty.documents()" class="carousel">
          <span carousel-label>Project Documents ({{ projectProperty.documents().length }})</span>
        </carousel>
      </div>

      @if (projectProperty.departments(); as departments) {
        <div class="my-6">
            <carousel [shouldAddBreadcrumb]="false" [dataSource]="departments" class="carousel-bottom-center">
                <span carousel-label>Departments ({{departments.length}})</span>
            </carousel>
        </div>
      }

    }
  }
</div>
